import { render } from "./InfosArticle.vue?vue&type=template&id=aa68770c&scoped=true"
import script from "./InfosArticle.vue?vue&type=script&lang=js"
export * from "./InfosArticle.vue?vue&type=script&lang=js"

import "./InfosArticle.vue?vue&type=style&index=0&id=aa68770c&lang=scss&scoped=true"

import exportComponent from "/Users/anthony/Documents/APP/SIMEF LAST/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa68770c"]])

export default __exports__